import {
  API_SERVICE,
  APPLICATION_ENV,
  ENV_PRODUCTION,
  ENV_SANDBOX,
  SERVICE_API,
  SERVICE_NOTIFICATIONS,
} from "../../constants/environment";

const apiUrls: Record<API_SERVICE, Record<APPLICATION_ENV, string>> = {
  [SERVICE_API]: {
    [ENV_PRODUCTION]: process.env.REACT_APP_API_URL ?? "",
    [ENV_SANDBOX]: process.env.REACT_APP_SANDBOX_API_URL ?? "",
  },
  [SERVICE_NOTIFICATIONS]: {
    [ENV_PRODUCTION]: process.env.REACT_APP_NOTIFICATIONS_MAIN_URL ?? "",
    [ENV_SANDBOX]: process.env.REACT_APP_NOTIFICATIONS_SANDBOX_URL ?? "",
  },
};

export function resolveApiUrl(
  environment: APPLICATION_ENV = ENV_SANDBOX,
  service: API_SERVICE = SERVICE_API
): string {
  return apiUrls[service][environment];
}
